import { Action } from 'redux';

import { SetAiLabel } from '../../../bootstrap/redux/actions/AppActionTypes';
import { IContentInfo } from '../../../spacesPlatform/models/IContentInfo';

export interface SetAiLabelAction extends Action {
  item: IContentInfo;
}

export function setAiLabelAction(item: SetAiLabelAction['item']): SetAiLabelAction {
  return {
    type: SetAiLabel,
    item,
  };
}
